import { MemberStatusCode, Member } from './members.types';
import { CANCELLED, EXPIRED, ACTIVE, PACKAGE_BASED } from './members.constants';
import { PackageState, MmsPackage } from 'src/mms-package/Types';

const areAllPackagesExpired = (packages: MmsPackage[]): boolean => {
  return packages.filter((p: MmsPackage) => new Date().getTime() - p.expiryDate < 0).length === 0; 
};

const areAllPackagesZeroRemaining = (packages: MmsPackage[]): boolean => {
  return packages.filter((p: MmsPackage) => p.remainingClasses !== 0).length === 0; 
};

export function getMembershipStatus(member: Member, packageState: PackageState): MemberStatusCode {

  if (member.cancelled) {
    return CANCELLED;
  } else if (member.memberType === PACKAGE_BASED) {
    const membersPackages: MmsPackage[] = packageState.packages.filter((p: MmsPackage) => p.memberId === member.id);

    if (!member.packageIds || (member.packageIds && member.packageIds.length === 0) ||
      membersPackages.length === 0 || areAllPackagesExpired(membersPackages) ||
      areAllPackagesZeroRemaining(membersPackages)
    ) {
      return EXPIRED;
    } else {
      return ACTIVE;
    }

  } else if (new Date().getTime() - member.endDate >= 0) {
    return EXPIRED;
  } else {   
    return ACTIVE;
  }
}



// WEBPACK FOOTER //
// ./src/members/members.util.tsx